var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.country === 'ru')?_vm._m(0):(_vm.country === 'en')?_vm._m(1):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('RuFlag',{staticClass:"app-menu-options__button--image"})
},function (){var _vm=this,_c=_vm._self._c;return _c('EnFlag',{staticClass:"app-menu-options__button--image"})
}]

export { render, staticRenderFns }